<template>
  <div class="quick-view-modal">
  <div class="quick-view-modal-inner">
    <div class="container">
      <div class="product-details">

        <!-- Product Details Left -->
        <div class="product-details-left">
          <div class="product-details-images slider-navigation-2">
            <a href="img/product/large-size/product-image-1.jpg">
              <img src="img/product/thumbnail-size/product-image-1.jpg" alt="product image">
            </a>
            <a href="img/product/thumbnail-size/product-image-2.jpg">
              <img src="img/product/thumbnail-size/product-image-2.jpg" alt="product image">
            </a>
            <a href="img/product/large-size/product-image-3.jpg">
              <img src="img/product/thumbnail-size/product-image-14.jpg" alt="product image">
            </a>
            <a href="img/product/large-size/product-image-4.jpg">
              <img src="img/product/thumbnail-size/product-image-15.jpg" alt="product image">
            </a>
            <a href="img/product/large-size/product-image-5.jpg">
              <img src="img/product/thumbnail-size/product-image-20.jpg" alt="product image">
            </a>
          </div>
          <div class="product-details-thumbs slider-navigation-2">
            <img src="img/product/small-size/product-image-1.jpg" alt="product image thumb">
            <img src="img/product/small-size/product-image-2.jpg" alt="product image thumb">
            <img src="img/product/small-size/product-image-3.jpg" alt="product image thumb">
            <img src="img/product/small-size/product-image-4.jpg" alt="product image thumb">
            <img src="img/product/small-size/product-image-5.jpg" alt="product image thumb">
          </div>
        </div>
        <!--// Product Details Left -->

        <!-- Product Details Right -->
        <div class="product-details-right">
          <h5 class="product-title">Aenean Eu Tristique</h5>

          <div class="ratting-stock-availbility">
            <div class="ratting-box">
              <span><i class="fa fa-star"></i></span>
              <span><i class="fa fa-star"></i></span>
              <span><i class="fa fa-star"></i></span>
              <span><i class="fa fa-star"></i></span>
              <span><i class="fa fa-star"></i></span>
            </div>
            <span class="stock-available">In stock</span>
          </div>

          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam fringilla augue nec est tristique auctor. Donec non est at libero vulputate rutrum. Morbi ornare lectus quis justo gravida semper. Nulla tellus mi, vulputate adipiscing cursus eu, suscipit id nulla. adipiscing cursus eu, suscipit id nulla.</p>

          <div class="price-box">
            <span class="pricebox-price">£80.00</span>
          </div>

          <div class="product-details-quantity">
            <div class="quantity-select">
              <input type="text" value="1">
            </div>
            <a href="#" class="add-to-cart-button">
              <span>ADD TO CART</span>
            </a>
          </div>

          <div class="product-details-color">
            <span>Color :</span>
            <ul>
              <li class="red"><span></span></li>
              <li class="green checked"><span></span></li>
              <li class="blue"><span></span></li>
              <li class="black"><span></span></li>
            </ul>
          </div>

          <div class="product-details-size">
            <span>Size :</span>
            <ul>
              <li class="checked"><span>S</span></li>
              <li><span>M</span></li>
              <li><span>L</span></li>
              <li><span>XL</span></li>
              <li><span>XXL</span></li>
            </ul>
          </div>

          <div class="product-details-categories">
            <span>Categories :</span>
            <ul>
              <li><a href="shop.html">Accessories</a></li>
              <li><a href="shop.html">Kids</a></li>
              <li><a href="shop.html">Women</a></li>
            </ul>
          </div>

          <div class="product-details-tags">
            <span>Tags :</span>
            <ul>
              <li><a href="shop.html">Electronic</a></li>
              <li><a href="shop.html">Television</a></li>
            </ul>
          </div>

          <div class="product-details-socialshare">
            <span>Share :</span>
            <ul>
              <li><a href="#"><i class="fa fa-facebook"></i></a></li>
              <li><a href="#"><i class="fa fa-twitter"></i></a></li>
              <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
              <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
              <li><a href="#"><i class="fa fa-instagram"></i></a></li>
            </ul>
          </div>
        </div>
        <!--// Product Details Right -->

      </div>
    </div>
    <button class="close-quickview-modal"><i class="fa fa-close"></i></button>
  </div>
  </div>
</template>

<script>
    export default {
        name: "quick"
    }
</script>

<style scoped>

</style>
